import { useCallback, useMemo } from 'react';

interface UseEmailDragArgs {
  draggingEmailId?: string | null;
  draggingSenderGroupKey?: string | null;
  draggingSenderGroupCount?: number | null;
}

export function useEmailDrag({
  draggingEmailId = null,
  draggingSenderGroupKey = null,
  draggingSenderGroupCount = null,
}: UseEmailDragArgs) {
  const isDraggingEmail = useMemo(() => Boolean(draggingEmailId), [draggingEmailId]);

  const getSenderGroupDragState = useCallback(
    (groupKey: string, defaultCount: number) => {
      const isDragging = draggingSenderGroupKey === groupKey;
      const count = isDragging
        ? draggingSenderGroupCount ?? defaultCount
        : defaultCount;
      return {
        isDragging,
        count,
      };
    },
    [draggingSenderGroupCount, draggingSenderGroupKey],
  );

  return {
    isDraggingEmail,
    getSenderGroupDragState,
  };
}
